const styles = {
  container: {
    fontSize: '13px',
    width: '240px',
    textAlign: 'center',
    margin: '0px',
  },
  label: {
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  row: {
    display: 'flex',
    width: '100%',
  },
  col_left: {
    width: '40%',
    textAlign: 'right',
    paddingRight: '8px',
    marginBottom: '3px',
  },
  col_right: {
    width: '60%',
    fontWeight: 'bold',
    textAlign: 'left',
  },
};

export default styles;
